import React from 'react'

import Backend from '../utils/Backend'
import AuthManager from '../utils/AuthManager'

import CompaniesTable from './components/tables/CompaniesTable'

export default class Companies extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {
    return (
      <div className="row">
        <CompaniesTable
          title="Clients"
        />
      </div>
    )
  }
}
